<div class="slide-documents">
  <div class="slide-documents__list">
    @for (document of documents; track document; let i = $index) {
      <div
        class="animate__animated slide-documents__document"
        [ngClass]="animationEnabled && slideData.animation"
        [style.animationDelay.ms]="slideData.animationDelay + i * 200"
        >
        <div class="content">
          <h5 class="name">{{document.name}}</h5>
          <small class="info">
            {{document.file.extension | uppercase}}, {{document.type}}
          </small>
        </div>
        <div class="actions">
          <a
            class="slide-documents__action-btn"
            [class.disabled]="!document.previewAvailable"
            [matTooltip]="'LIBRARY.preview_unavailable' | translate"
            [matTooltipDisabled]="document.previewAvailable"
            matTooltipPosition="above"
            (click)="preview(document)">
            <lib-icon [icon]="document.previewAvailable ? 'eye' : 'eye-slash'"></lib-icon>
          </a>
          @if (documentDownload && document?.allowDownload) {
            <a
              class="slide-documents__action-btn slide-documents__action-btn--download"
              [download]="document.file.filename"
              (click)="download(document)">
              @if (document.id !== loadingDocumentId) {
                <lib-icon icon="download-simple"></lib-icon>
              } @else {
                <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
              }
            </a>
          }
        </div>
      </div>
    }
  </div>
</div>
